import __base_store from '@/store/__base_store'

/**
 * Store de tareas.
 */
export default __base_store({
	state: {
		model_name: 'task',
	},
})

